const BOOKING_ACCESS_MISMATCH_KEY = 'occasiaBookingAccessMismatch';

export const saveBookingAccessMismatch = ({ bookingEmail, loggedInEmail, returnPath }) => {
  try {
    sessionStorage.setItem(
      BOOKING_ACCESS_MISMATCH_KEY,
      JSON.stringify({
        bookingEmail: bookingEmail || '',
        loggedInEmail: loggedInEmail || '',
        returnPath: returnPath || ''
      })
    );
  } catch {
    // ignore storage errors
  }
};

export const consumeBookingAccessMismatch = () => {
  try {
    const raw = sessionStorage.getItem(BOOKING_ACCESS_MISMATCH_KEY);
    sessionStorage.removeItem(BOOKING_ACCESS_MISMATCH_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const redirectForBookingAccessMismatch = (navigate, payload) => {
  saveBookingAccessMismatch(payload);
  navigate('/', { replace: true });
};
